<template>
  <div class="content">
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 d-inline-block mb-0">
            {{ $t("menu.import_agent_number") }}
          </h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>

        <div class="col-lg-6 col-5 text-right">
          <base-button size="md" type="neutral" @click="initImport()">{{
            $t("upload")
          }}</base-button>
          <base-button size="md" type="neutral" @click="clearImport()">{{
            $t("clear")
          }}</base-button>

        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
            <h3 class="mb-0">{{ $t("menu.import_agent_number") }}</h3>
          </template>
          <div>
            <div
              class="
                col-12
                d-flex
                justify-content-center justify-content-sm-between
                flex-wrap
              "
            >
              <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <div>
                <base-input
                  v-model="searchQuery"
                  prepend-icon="fas fa-search"
                  :placeholder="$t('search')"
                >
                </base-input>
              </div>
            </div>
            <el-table
              :data="queriedData"
              row-key="id"
              header-row-class-name="thead-light"
              @sort-change="sortChange"
              @selection-change="selectionChange"
            >
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                v-bind="column"
              >
              </el-table-column>
              <el-table-column
                min-width="120px"
                align="right"
                :label="$t('number.charge')"
              >
                <div slot-scope="{ row }" class="d-flex">
                  {{ getChargeNumberType(row) }}
                </div>
              </el-table-column>
              <el-table-column
                min-width="200px"
                align="left"
                :label="$t('status')"
              >
                <div slot-scope="{ row }" class="d-flex">
                  {{ getStatus(row) }}
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="
              col-12
              d-flex
              justify-content-center justify-content-sm-between
              flex-wrap
            "
            v-if="queriedData.length != 0"
          >
            <div class="">
              <p class="card-category">
                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }} {{ to }}
                {{ $t("of") }}
                {{ total }}
                <span v-if="selectedRows.length">
                  - &nbsp; &nbsp; {{ selectedRows.length }}
                  {{ $t("row_select") }}
                </span>
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>

    <modal :show.sync="showAddModal" modal-classes="modal-secondary">
      <form class="new-event--form" @submit.prevent="saveEvent">
        <div class="form-group row" v-if="isDtacAdmin">
          <label
            for="import-corporate"
            class="col-md-2 col-form-label form-control-label"
            >{{ $t("menu.corporate") }}</label
          >
          <div class="col-md-10">
            <base-input
              input-classes="form-control-alternative new-event--title"
            >
              <el-select id="import-corporate"
                v-model="enterpriseId"
                :placeholder="$t('menu.corporate')"
                filterable
              >
                <el-option
                  v-for="option in corporate"
                  :key="option.label"
                  :label="option.Name"
                  :value="option.ID"
                >
                </el-option>
              </el-select>
            </base-input>
          </div>
        </div>

        <div class="form-group row" v-if="isDtacAdmin">
          <label
            for="file"
            class="col-md-2 col-form-label form-control-label"
            >{{ $t("menu.corporate") }}</label
          >
          <div class="col-md-10">
            <div class="custom-file">
              <input
                type="file"
                class="custom-file-input"
                id="file"
                ref="file"
                lang="en"
                v-bind="$attrs"
                v-on="listeners"
              />
              <label class="custom-file-label" for="file">
                {{ label }}
              </label>
            </div>
          </div>
        </div>

        <input type="hidden" class="new-event--start" />
        <input type="hidden" class="new-event--end" />
      </form>

      <template slot="footer">
        <button
          type="submit"
          class="btn btn-md btn-primary"
          @click="handleImport()"
          v-if="enterpriseId != null && files != null"
        >
          {{ $t("import") }}
        </button>
        <button
          type="button"
          class="btn btn-md btn-link ml-auto"
          @click="showAddModal = false"
        >
          {{ $t("close") }}
        </button>
      </template>
    </modal>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";

export default {
  mixins: [clientPaginationMixin],
  components: {
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  computed: {
    ...mapGetters({
      isCorporateAdmin: "Auth/isCorporateAdmin",
      isDtacAdmin: "Auth/isDtacAdmin",
      isReadOnly: "Auth/isReadOnly",
      tableDataOrg: "AgentNumber/getDataImport",
      corporate: "Corporate/getData",
    }),
    listeners() {
      return {
        ...this.$listeners,
        change: this.fileChange,
      };
    },
    label() {
      let fileNames = [];
      for (let file of this.files) {
        fileNames.push(file.name);
      }
      return fileNames.length ? fileNames.join(", ") : this.initialLabel;
    },
    tableData: function () {
      if (this.$route.query.id != null) {
        return this.tableDataOrg.filter((m) => {
          return m.EnterpriseID == "" + this.$route.query.id;
        });
      }

      return this.tableDataOrg;
    },
    tableColumns: function () {
      return [
        {
          prop: "Number",
          label: this.$t("menu.number"),
          minWidth: 90,
          sortable: true,
        },
        {
          prop: "EnterpriseName",
          label: this.$t("menu.corporate"),
          minWidth: 100,
          sortable: true,
        },
        {
          prop: "Email",
          label: this.$t("email"),
          minWidth: 90,
          sortable: true,
        },
      ];
    },
  },
  data() {
    return {
      propsToSearch: ["Number", "Email"],
      selectedRows: [],
      showAddModal: false,
      md_charge_number: 1,
      md_email: "",
      rowEdit: {
        ID: 0,
        Number: "",
      },
      optionChargeNumber: [
        {
          label: this.$t("menu.pilot_number"),
          value: "1",
        },
        {
          label: this.$t("menu.agent_number"),
          value: "2",
        },
      ],
      files: [],
      enterpriseId: null,
    };
  },
  mounted() {
    this.listDataImport();
    this.listCorporate();
  },
  methods: {
    ...mapActions("AgentNumber", ["resetPassword"]),
    ...mapActions({
      createData: "AgentNumber/createData",
      updateData: "AgentNumber/updateData",
      deleteData: "AgentNumber/deleteData",
      listDataImport: "AgentNumber/listDataImport",
      syncPackage: "AgentNumber/syncPackage",
      comPortalLogin: "AgentNumber/comPortalLogin",
      listCorporate: "Corporate/listData",
      importNumber: "AgentNumber/importNumber",
      clearImportNumber: "AgentNumber/clearImportNumber",
    }),
    getChargeNumberType(row) {
      if (row.ChargeType == 1) return this.$t("menu.pilot_number");
      else return this.$t("menu.agent_number");
    },
    initImport() {
      this.showAddModal = true;
      this.enterpriseId = null;
      this.files = [];
    },
    fileChange(evt) {
      this.files = evt.target.files;
      this.$emit("change", this.files);
    },
    getStatus(row) {
      if (row.Status == 1) {
        return "Success";
      } else if (row.Status == 0) {
        return "Provisioning";
      } else if (row.Status == 5) {
        // Backend (V4 worker, issue #24) writes error_log as
        //   "errors.<key>|<freeform detail>"
        // so we can show a translated message plus the raw cause.
        // Older rows have a plain string — fall through and show as-is.
        const log = row.ErrorLog || "";
        if (/^errors\.[^|]+\|/.test(log)) {
          const sep = log.indexOf("|");
          const key = log.slice(0, sep);
          const detail = log.slice(sep + 1);
          const translated = this.$t(key);
          // If $t falls back (returns the key itself), don't double-print it.
          if (translated && translated !== key) {
            return detail ? translated + ": " + detail : translated;
          }
          return detail || log;
        }
        return log;
      } else {
        return "--";
      }
    },
    handleImport(index, row) {
      const formData = new FormData();
      //customFileLang
      // this.files = this.$refs.file.files[0];
      formData.append("file", this.$refs.file.files[0]);
      formData.append("enterpriseID", this.enterpriseId);

      this.importNumber(formData)
        .then((res) => {
          swal.fire({
            title: this.$t("upload_number_success"),
            text: this.$t("import_inprogress"),
            icon: "success",
            confirmButtonClass: "btn btn-primary btn-fill",
            buttonsStyling: false,
          });
        this.listDataImport();
        })
        .catch((err) => {
          swal.fire({
            title: this.$t("errors.subs.import_number"),
            text: "",
            icon: "error",
            confirmButtonClass: "btn btn-danger btn-fill",
            buttonsStyling: false,
          });
        });
      this.showAddModal = false;
    },
    clearImport() {

      this.clearImportNumber(null)
        .then((res) => {
          swal.fire({
            title: this.$t("menu.import_agent_number"),
            text: this.$t("delete_success"),
            icon: "success",
            confirmButtonClass: "btn btn-primary btn-fill",
            buttonsStyling: false,
          });
        this.listDataImport();
        })
        .catch((err) => {
          swal.fire({
            title: this.$t("menu.import_agent_number"),
            text: this.$t("delete_success"),
            icon: "error",
            confirmButtonClass: "btn btn-danger btn-fill",
            buttonsStyling: false,
          });
        });
      this.showAddModal = false;
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
  },
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
